import { Pie, Bar } from "react-chartjs-2";

type StatsProps = {
	stats: {
		sentiments: { [key: string]: number };
		replies: { [key: string]: number };
		demographics: {
			gender: { [key: string]: number };
			region: { [key: string]: number };
			ageRange: { [key: string]: number };
			job: { [key: string]: number };
		};
	};
};

export default function MyFactStats({ stats }: StatsProps) {
	return (
		<div className="MyFactStats">
			<h2>게시글 통계</h2>

			<div>
				<h3>감정 표현 비율</h3>
				<div className="chart-wrapper">
					<Pie data={{
						labels: Object.keys(stats.sentiments),
						datasets: [{ data: Object.values(stats.sentiments) }]
					}} />
				</div>
			</div>

			<div>
				<h3>답글 비율</h3>
				<div className="chart-wrapper">
					<Pie data={{
						labels: Object.keys(stats.replies),
						datasets: [{ data: Object.values(stats.replies) }]
					}} />
				</div>
			</div>

			<div>
				<h3>성별 분포</h3>
				<div className="chart-wrapper">
					<Bar data={{
						labels: Object.keys(stats.demographics.gender),
						datasets: [{ data: Object.values(stats.demographics.gender) }]
					}} />
				</div>
			</div>

			<div>
				<h3>지역 분포</h3>
				<div className="chart-wrapper">
					<Bar data={{
						labels: Object.keys(stats.demographics.region),
						datasets: [{ data: Object.values(stats.demographics.region) }]
					}} />
				</div>
			</div>

			<div>
				<h3>연령대 분포</h3>
				<div className="chart-wrapper">
					<Bar data={{
						labels: Object.keys(stats.demographics.ageRange),
						datasets: [{ data: Object.values(stats.demographics.ageRange) }]
					}} />
				</div>
			</div>

			<div>
				<h3>직업 분포</h3>
				<div className="chart-wrapper">
					<Bar data={{
						labels: Object.keys(stats.demographics.job),
						datasets: [{ data: Object.values(stats.demographics.job) }]
					}} />
				</div>
			</div>
		</div>
	);
}
